import { render, staticRenderFns } from "./Filiais.vue?vue&type=template&id=3ae367f0"
import script from "./Filiais.vue?vue&type=script&lang=js"
export * from "./Filiais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports